export default {
	state: () => ({}),
	mutation: {},
	actions: {},
	getters: {},
};



// WEBPACK FOOTER //
// ./src/store/Task/modules/banner.js